import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { getMonths, kFormatter } from "../../helpers";
import useLogout from "../../common/useLogout";
import findIndex from "lodash/findIndex";
import { getMonthlyTotalCalls } from "../../../queries/metrics";
import { updateObjectInArray } from "../../../redux/reducers/helpers";
import isEmpty from "lodash/isEmpty";

const chartDataset = JSON.stringify({
  labels: getMonths(),
  datasets: [
    {
      label: "Total Calls",
      data: [],
      backgroundColor: "#de337c",
      borderColor: "#de337c",
    },
  ],
});

const options = {
  legend: {
    display: false,
    position: "bottom",
  },
  tooltips: {
    intersect: false,
    xPadding: 15,
    yPadding: 15,
    callbacks: {
      label: function (t, d) {
        const dstLabel = d.datasets[t.datasetIndex].label;
        const yLabel = t.yLabel;
        return " " + dstLabel + ": " + yLabel;
      },
    },
  },
  scales: {
    xAxes: [
      {
        stacked: true,
        gridLines: {
          display: false,
        },
        ticks: {
          padding: 5,
        },
      },
    ],
    yAxes: [
      {
        stacked: true,
        gridLines: {
          drawBorder: false,
          zeroLineColor: "rgba(0,0,0,.5)",
        },
        ticks: {
          beginAtZero: true,
          padding: 15,
          callback: function (val) {
            return kFormatter(val);
          },
        },
      },
    ],
  },
};

const FinstreamVFTotalCallBarChart = ({ cableApp, application }) => {
  const [handleLogout] = useLogout();
  const [dataset, setDataset] = useState(JSON.parse(chartDataset));

  const createDataset = (data) => {
    const message = data.message[0];
    if (data.resource === "monthly_total_calls") {
      const objIndex = findIndex(dataset.datasets, (dataset) => {
        return dataset.label === "Total Calls";
      });
      dataset.datasets[objIndex].data = message.datapoints;
      setDataset({
        ...dataset,
        datasets: updateObjectInArray(
          dataset.datasets,
          dataset.datasets[objIndex],
          "label"
        ),
      });
    }
  };

  const handleEmptyDataSet = () => {
    setDataset(JSON.parse(chartDataset));
  };

  useEffect(() => {
    cableApp[`finstreamvf-chargeable-calls`] =
      cableApp.cable.subscriptions.create(
        {
          channel: "ChartsChannel",
          chart_resource: "application-chargeable-calls-finstreamvf",
        },
        {
          connected: () => {
            getMonthlyTotalCalls({
              id: application.id,
              service_name: "finstreamvf",
              chart_resource: "application-chargeable-calls-finstreamvf",
            });
          },
          received: (data) => {
            if (!isEmpty(data.message[0])) {
              createDataset(data);
            } else {
              handleEmptyDataSet();
            }
          },
          rejected: () => {
            handleLogout();
          },
        }
      );
    return () => {
      cableApp["finstreamvf-chargeable-calls"].unsubscribe();
    };
  }, []);

  return <Bar data={dataset} options={options} />;
};

FinstreamVFTotalCallBarChart.propTypes = {};

export default FinstreamVFTotalCallBarChart;
